import { ApiClient } from 'app/service/api-service'
import { ActivityEngagementEndPoint } from './constant'
import {
  IParamsGetActivityEngagement,
  IPayloadCreateActivityEngagement,
  IPayloadUpdateActivityEngagement,
} from './model'

export const requestGetActivityEngagement = (
  body: IParamsGetActivityEngagement,
) =>
  ApiClient.Post({
    url: ActivityEngagementEndPoint.GET,
    body,
  })

export const requestPostCreateActivityEngagement = (
  body: IPayloadCreateActivityEngagement,
) =>
  ApiClient.Post({
    url: ActivityEngagementEndPoint.CREATE,
    body,
  })

export const requestUpdateActivityEngagement = (
  body: IPayloadUpdateActivityEngagement,
) =>
  ApiClient.Put({
    url: ActivityEngagementEndPoint.UPDATE,
    body,
  })

export const requestDeleteActivityEngagement = (listId: number[]) =>
  ApiClient.Put({
    url: ActivityEngagementEndPoint.DELETE,
    body: { listId },
  })

// get detail unit
export const requestGetDetailActivityEngagement = (id: number) =>
  ApiClient.Get({
    url: ActivityEngagementEndPoint.DETAIL,
    params: { id },
  })
